import * as React from 'react';

import { UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './RequestFormModalHeader.css';

export const RequestFormModalHeader: React.FC = () => {
  return (
    <div className={styles['request-form-modal-header']}>
      <div className={styles['title']}>
        <UIHeading2>Расскажите, что вы ищете</UIHeading2>
      </div>
      <UIText1>
        Консультант изучит ваши пожелания и перезвонит в течение суток c&nbsp;индивидуальными предложениями
      </UIText1>
    </div>
  );
};
